class ProductLowStock extends HTMLElement {
  connectedCallback() {
    const section = this.closest('[data-section-type="product"]');
    section?.addEventListener('variantChange', this.#handleVariantChange);
  }

  disconnectedCallback() {
    const section = this.closest('[data-section-type="product"]');
    section?.removeEventListener('variantChange', this.#handleVariantChange);
  }

  #handleVariantChange = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const data = window.lowStockData?.[this.dataset.blockId];
    if (!data) return;

    const qty = data.inventory[variant.id];
    // undefined = variant not in our product (shouldn't happen), null = not tracked by Shopify
    if (qty === undefined) return;

    const { low, medium, regular } = data.thresholds;
    let message = '';
    let level = '';
    let color = '';

    if (qty !== null && qty <= low.qty) {
      if (low.enabled) {
        message = low.showQty ? low.message.replace('#', qty) : low.message;
        level = 'low';
        color = low.color;
      }
    } else if (qty !== null && qty <= medium.qty) {
      if (medium.enabled) {
        message = medium.showQty ? medium.message.replace('#', qty) : medium.message;
        level = 'medium';
        color = medium.color;
      }
    } else if (qty !== null && qty <= regular.qty) {
      if (regular.enabled) {
        message = regular.showQty ? regular.message.replace('#', qty) : regular.message;
        level = 'regular';
        color = regular.color;
      }
    }

    if (message) {
      const span = document.createElement('span');
      span.className = `product-low-stock__message product-low-stock__message--${level}`;
      span.style.color = color;
      span.textContent = message;
      this.replaceChildren(span);
    } else {
      this.replaceChildren();
    }
  };
}

if (!customElements.get('product-low-stock')) {
  customElements.define('product-low-stock', ProductLowStock);
}
